import { css } from "emotion";

import { colors } from "@cobliteam/base-components/src/styles/colors";

export const filtersSection = css`
  button {
    white-space: nowrap;
  }
`;

export const filterOverlay = css`
  width: 320px;
`;

export const chipsWrapper = css`
  display: inline-flex;
  gap: 10px;
  margin: 0 0 10px;
  flex-wrap: wrap;
  align-items: center;
`;

const square = css`
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  margin: 0px 5px;
  background: ${colors.gray.default};
`;

export const legend = css`
  > span {
    color: ${colors.gray.dark};

    &:nth-child(1) {
      &:before {
        ${square}
        background: ${colors.primary.default};
      }
    }
    &:nth-child(2) {
      &:before {
        ${square}
        background: ${colors.gray.light};
      }
    }
    &:nth-child(3) {
      &:before {
        ${square}
        background: ${colors.warning.default};
      }
    }
    &:nth-child(4) {
      &:before {
        ${square}
        background: ${colors.success.default};
      }
    }
  }
`;
